<template>
  <div class="flex flex-col gap-y-3">
    <label v-if="formElement.properties.label">{{ formElement.properties.label }} </label>
    <div class="flex flex-col gap-3 md:flex-row">
      <VcCheckbox v-model="isCheckboxChecked" :name="formElement.key" :value="isCheckboxChecked">
        <p v-dompurify-html="formElement.properties.checkboxLabel"></p>
      </VcCheckbox>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref, watch } from "vue";
import type { ExtendedFormElement } from "../types";

interface IProps {
  formElement: ExtendedFormElement;
  modelValue?: string;
}

export interface IEmits {
  (event: "update:modelValue", value?: string): void;
}

const emit = defineEmits<IEmits>();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<IProps>();
//const model = defineModel<string>();

const isCheckboxChecked = ref(false);

onBeforeMount(() => {
  //model.value = "false"; // Default to false for the checkbox
  emit("update:modelValue", "false");
});

watch(
  isCheckboxChecked,
  (newValue) => {
    //model.value = newValue ? "true" : "false"; // Update model based on checkbox state
    //Logger.debug(newValue);
    //Logger.debug(model.value);
    emit("update:modelValue", newValue ? "true" : "false");
  },
  { immediate: true },
);
</script>
